export default "__VITE_ASSET__Cb1MClC2__"